import { render, staticRenderFns } from "./VistaAlegre.vue?vue&type=template&id=2f4da942&scoped=true"
import script from "./VistaAlegre.vue?vue&type=script&lang=js"
export * from "./VistaAlegre.vue?vue&type=script&lang=js"
import style0 from "./VistaAlegre.vue?vue&type=style&index=0&id=2f4da942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4da942",
  null
  
)

export default component.exports